"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingCoreOrderContractorRoleEnum = void 0;
/**
 * Роли контрагента.
 *
 * - buyer: покупатель (например ученик)
 * - seller: продавец (например, преподаватель, автор коллекции)
 * - broker: комиссионер (например, школа)
 */
var BillingCoreOrderContractorRoleEnum;
(function (BillingCoreOrderContractorRoleEnum) {
  /** Покупатель */
  BillingCoreOrderContractorRoleEnum["BUYER"] = "BUYER";
  /** Продавец */
  BillingCoreOrderContractorRoleEnum["SELLER"] = "SELLER";
  /** Комиссионер */
  BillingCoreOrderContractorRoleEnum["BROKER"] = "BROKER";
})(BillingCoreOrderContractorRoleEnum = exports.BillingCoreOrderContractorRoleEnum || (exports.BillingCoreOrderContractorRoleEnum = {}));
